import React, { useState } from "react";
import { FaEdit, FaEye, FaTrashAlt } from "react-icons/fa";

const ProductTable = ({ products, productDetails, onEdit, onDelete }) => {

  console.log("product table", products);

  return (
    <div className="table-responsive bg-white">
      <table className="table ">
        <thead className=" bg-info bg-opacity-50">
          <tr>
            <th scope="col">
              <input type="checkbox" />
            </th>
            <th scope="col"></th>
            <th scope="col">Product Name</th>
            <th scope="col">Product Description</th>
            <th scope="col">Price</th>
            <th scope="col">Category</th>
            <th scope="col">Stock</th>
            {/* <th scope="col">Vendor</th> */}
            {/* <th scope="col">Published On</th> */}
            <th scope="col" className="text-center">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => (
            <tr key={index} className="" style={{ verticalAlign: "middle" }}>
              <td>
                <input type="checkbox" />
              </td>
              <td>
                {" "}
                <img
                  alt={product.name}
                  height={50}
                  width={60}
                  src={product.image}
                  className=" border rounded-1 p-1"
                ></img>{" "}
              </td>
              <td>{product.name}</td>
              <td>{product.description.slice(0, 70) + (product.description.length > 70 ? "..." : "")}</td>
              <td>{product.price}</td>
              <td>{product.category.name}</td>
              <td>{product.stock}</td>
              {/* <td>{product.tags.join(', ')}</td> */}
              {/* <td>{product.vendor}</td> */}
              {/* <td>{product.updated_at}</td> */}
              <td className=" text-center">
              <button
                className="btn btn-success btn-xs"
                data-bs-toggle="modal"
                data-bs-target="#productModal"
                onClick={() => productDetails(product)}
              >
                <FaEye />
              </button>
              <button
                className="btn btn-info btn-xs mx-1 text-center"
                data-bs-toggle="modal"
                data-bs-target="#productModal"
                onClick={() => onEdit(product)}
              >
                <FaEdit />
              </button>
              <button
                className="btn btn-danger btn-xs"
                data-bs-toggle="modal"
                data-bs-target="#productModal"
                onClick={() => onDelete(product)}
              >
                <FaTrashAlt />
              </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;
